
import { filter } from "lodash";
// import React from 'react';
import React, { useEffect, useState } from "react";
// import { useEffect, useState } from 'react';
// material
import {
  Card,
  Table,
  Stack,
  Avatar,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Button,
  MenuItem,
  Checkbox,
  FormControlLabel,
  FormGroup,
} from "@mui/material";
// components
import Page from "../components/Page";

import Scrollbar from "../components/Scrollbar";

import SearchNotFound from "../components/SearchNotFound";
import {
  UserListHead,
  UserListToolbar,
  UserMoreMenu,
} from "../sections/@dashboard/user";
// mock
import { useNavigate } from "react-router-dom";
import SyncLoader from "react-spinners/SyncLoader";
import { ExportCSV } from "../utils/ExportCSV";
import { ToastContainer, toast } from "react-toastify";

// for Dialog box
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import axios from "axios"; // for axios request

import { CSVLink } from "react-csv"; // for CSV file download
import { RHFTextField } from "../components/hook-form";

import dayjs from "dayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { ro } from "date-fns/locale";
// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: "", label: "S.No", alignRight: false },
  { id: "enrolid", label: "Enrollment No.", alignRight: false },
  { id: "StudentName", label: "Name", alignRight: false },
  { id: "mobileNumber", label: "Phone No.", alignRight: false },
  { id: "email", label: "Email", alignRight: false },
  { id: "purchaseAt", label: "Purchased At", alignRight: false },
  { id: "regCategory", label: "Request Category", alignRight: false },
  // { id: 'paid', label: 'Paid', alignRight: false },
  // { id: 'Status', label: 'Status', alignRight: false },
  { id: "Action", label: "Action", alignRight: false },
];

// ----------------------------------------------------------------------

function parseDMYDate(dateStr) {
  if (!dateStr || typeof dateStr !== "string") return new Date(0);
  const parts = dateStr.trim().split(" ");
  const dateParts = parts[0].split("-");
  const timeParts = parts[1] ? parts[1].split(":") : ["00", "00", "00"];
  return new Date(
    parseInt(dateParts[2], 10),
    parseInt(dateParts[1], 10) - 1,
    parseInt(dateParts[0], 10),
    parseInt(timeParts[0], 10),
    parseInt(timeParts[1], 10),
    parseInt(timeParts[2], 10)
  );
}

function formatDateTimeIST(dateStr) {
  if (!dateStr || typeof dateStr !== "string") return "N/A";
  const parsedDate = parseDMYDate(dateStr);
  if (isNaN(parsedDate.getTime())) return dateStr;
  
  const day = String(parsedDate.getDate()).padStart(2, '0');
  const month = String(parsedDate.getMonth() + 1).padStart(2, '0');
  const year = parsedDate.getFullYear();
  
  let hours = parsedDate.getHours();
  const minutes = String(parsedDate.getMinutes()).padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12;
  hours = hours ? hours : 12;
  
  return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
}

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "asc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array?.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] + b[1];
  });

  if (query) {
    return filter(array, (_user) => {
      const studentNameMatch =
        _user?.name && _user?.name.toLowerCase().includes(query.toLowerCase());
      const emailMatch =
        _user?.email && _user.email.toLowerCase().includes(query.toLowerCase());
      const phoneMatch =
        _user?.mobileNumber &&
        _user.mobileNumber.toLowerCase().includes(query.toLowerCase());
      return studentNameMatch || emailMatch || phoneMatch;
    });
  }

  return stabilizedThis.map((el) => el[0]);
}

export default function UserReport() {
  //date-time
  const [starting, setStarting] = React.useState(dayjs().startOf('day'));
  const [ending, setEnding] = React.useState(dayjs().endOf('day'));
  const [dateRangeOption, setDateRangeOption] = useState("today");
  const [searched, setSearched] = useState(true);

  const [exportDialogOpen, setExportDialogOpen] = useState(false);
  const [selectedColumns, setSelectedColumns] = useState({
    enrollId: true,
    name: true,
    phone: true,
    email: true,
    regDateTime: true,
    regCategory: true,
  });

  const handleColumnToggle = (column) => {
    setSelectedColumns(prev => ({
      ...prev,
      [column]: !prev[column]
    }));
  };

  const handleChange = (newValue) => {
    setStarting(newValue);
    setDateRangeOption("custom");
  };
  const handleChangeTwo = (newValue) => {
    setEnding(newValue);
    setDateRangeOption("custom");
  };

  const handleDateRangeOptionChange = (event) => {
    const option = event.target.value;
    setDateRangeOption(option);
    const now = dayjs();
    let newStarting = starting;
    let newEnding = ending;

    if (option === "today") {
      newStarting = now.startOf("day");
      newEnding = now.endOf("day");
    } else if (option === "1week") {
      newStarting = now.subtract(1, "week");
      newEnding = now;
    } else if (option === "1month") {
      newStarting = now.subtract(1, "month");
      newEnding = now;
    }

    setStarting(newStarting);
    setEnding(newEnding);
  };

  // Code for handling Dialog box
  const [showDownload, setShowDownload] = useState(false);
  const [download, setDownload] = useState(true);
  const [statusUser, setStatusUser] = useState();
  const [statusStaus, setStatusStatus] = useState();
  const [errorOTP, setErrorOtp] = useState();
  const [open, setOpen] = useState(false);
  const [docCount,setDocCount]=useState(0)
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const sendOtp = () => {
    const token = localStorage.getItem("token");
    const authToken = token;
    const config = {
      headers: {
        "content-type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
    };
    const data = {
      action: "Exporting All Users Data",
    };

    axios
      .post(
        `${process.env.REACT_APP_LIVE_URL}/adminTeacher/send-otp`,
        data,
        config
      )
      .then((response) => {})
      .catch((e) => {
        //console.log(e);
      });
  };
  const verifyOtp = () => {
    //console.log(document.getElementById('name').value);
    const token = localStorage.getItem("token");
    const authToken = token;
    const config = {
      headers: {
        "content-type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
    };
    const data = {
      otp: document.getElementById("name").value,
    };

    axios
      .post(
        `${process.env.REACT_APP_LIVE_URL}/adminTeacher/verify-otp`,
        data,
        config
      )
      .then((response) => {
        // //console.log(response);
        if (response.data.status == false) {
          setErrorOtp("Invalid Otp");
        } else {
          if (showDownload) {
            setShowDownload(false);
            setDownload(false);
          } else {
            //console.log("status");
            //console.log(statusStaus);
            const data1 = {
              isActive: !statusStaus,
            };
            axios
              .post(
                `${process.env.REACT_APP_LIVE_URL}/adminTeacher/activeInactiveStudent/${statusUser}`,
                data1,
                config
              )
              .then((response) => {
                //console.log(response);
              });

            handleClose();

            toast.success("Status Updated");
            setTimeout(() => window.location.reload(), 1000);

            setErrorOtp("");
          }
        }
      })
      .catch((e) => {
        //console.log(e);
      });
  };

  const [page, setPage] = useState(0);
  const [count, setCount] = useState(0);

  const [order, setOrder] = useState("asc");

  const [selected, setSelected] = useState([]);

  const [orderBy, setOrderBy] = useState("name");

  const [filterName, setFilterName] = useState("");

  const [rowsPerPage, setRowsPerPage] = useState(5);
  const navigate = useNavigate();
  const [users, usersSet] = useState();
  const [loading, setLoading] = useState(true);
  const [loadingForFilter, setLoadingForFilter] = useState(true);
  const [type, setType] = useState("all");
  //Getting Details
  useEffect(() => {
    const token = localStorage.getItem("token");
    async function fetchUsers() {
      const fullResponse = await fetch(
        `${process.env.REACT_APP_LIVE_URL}/adminTeacher/admingetallstudentsdetails?page=${page}&limit=${rowsPerPage}&search=${filterName}`,
        {
          method: "GET",
         
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const responseJson = await fullResponse.json();
      // console.log(responseJson.data);
      usersSet(responseJson.data);
      // setDocCount(responseJson?.count)
      // if(type=="free"||type=="all"){
      // setFilterSearch(responseJson.data.reverse());
      // }
      // else
      setCount(responseJson?.count || 0);
      // //console.log(responseJson.data);
      setLoading(false);
      if (responseJson.msg === "not an admin") {
        localStorage.removeItem("isLoggedIn");
        localStorage.removeItem("details");
        navigate("/");
      }
    }

    fetchUsers();
  }, [filterName,page,type,rowsPerPage]);


  const [valueId, setValueId] = useState("all");
  const [userCount, setUserCount] = useState(0);
  const [streamCategory, setStreamCategory] = useState();
  // const [isPaid,setisP]
  // const [type,setType]=useState();

  React.useEffect(() => {
    const token = localStorage.getItem("token");
    // const token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6InNkY2FtcHVzQHRyYW5kby5pbiIsInN0dWRlbnRJZCI6IjNjZjcwODYwLTZjMWMtMTFlZC04YjVlLWMxZjc4OTdkMzM5OCIsImlhdCI6MTY5NjkxMzkwNSwiZXhwIjoxNjk3MDg2NzA1fQ.6fO3U1pCsbTOO2AVgjDOohKa4b73wtyG9o3zLksTJk8";
    async function fetchUsers() {
      // const fullResponse = await fetch(`${process.env.REACT_APP_LIVE_URL}/adminPanel/getBatchesDetails`, {

      const fullResponseCategory = await fetch(
        `${process.env.REACT_APP_LIVE_URL}/adminPanel/getCategory?type=Stream`,
        {
          method: "GET",

          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const responseJsonCatergory = await fullResponseCategory.json();
      setStreamCategory(responseJsonCatergory.data);
    }
    fetchUsers();
    if (searched) {
      handleFilter(type, valueId);
    }
  }, [filterName,page,rowsPerPage, searched]);

  const [filterSearch, setFilterSearch] = useState([]);
  const handleFilter = async (selectedType, valueIdType) => {
    setSearched(true);
    setLoadingForFilter(true);
    // setPage(0);
    let token = localStorage.getItem("token");
    const data = {
      type: selectedType ? type : selectedType,
      category: valueIdType ? valueId : valueIdType,
      // startAt:starting.$d? starting.$d:'2022-01-01T08:59:55.000Z',
      // endAt:ending.$d? ending.$d:new Date().toISOString(),
      startAt: starting.$d,
      endAt: ending.$d,
      page:page,
      limit:rowsPerPage,
      search:filterName
    };
    // console.log('data',data);
    // console.log(starting.$d);
    // console.log(ending.$d);
    try {
      const res = await fetch(
        `${process.env.REACT_APP_LIVE_URL}/adminPanel/usersReport`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ ...data }),
        }
      );
      const result = await res.json();
      // console.log(result.data);
      // debugger;

      // setFilterSearch(result.data);
      // const results=result?.result?.map((item)=>{
      //   // return {...e,...e.user}

      //   return  {enrollId: item.user.enrollId,
      //   name: item.user.FullName,
      //   phone: item.user.mobileNumber,
      //   email: item.user.email,
      //   id: item._id,
      //   regCategory: item.user.Stream,
      //   regDateTime: item.created_at}
      // })
      setFilterSearch(result.data);

      setUserCount(result?.count)
      setCount(result?.count)
      // console.log("Resulut : ",results)
      setLoadingForFilter(false);
    } catch (error) {
      // console.log(error);
    }
    // navigate('/dashboard', { replace: true });
  };
  // console.log(filterSearch)

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = filterSearch?.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };


  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
    // usersSet(())
    setFilterSearch((prevData) => {
      const searchTerm = event.target.value?.toLowerCase(); // Get the search term in lowercase
      return prevData.filter(data => 
        data?.name?.toLowerCase()?.includes(searchTerm) || 
        data?.email?.toLowerCase()?.includes(searchTerm) || 
        data?.phone?.toLowerCase()?.includes(searchTerm)
      );
    });

    setPage(0)
  };

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - filterSearch?.length) : 0;

  const filteredUsers = searched ? applySortFilter(
    filterSearch ? filterSearch : ["no"],
    getComparator(order, orderBy),
    filterName
  ) : [];

  const csvData = filteredUsers.map((item) => {
    const rowData = {};
    if (selectedColumns.enrollId) rowData["Enrollment No."] = item?.enrollId || "N/A";
    if (selectedColumns.name) rowData["Name"] = item?.name || "N/A";
    if (selectedColumns.phone) rowData["Phone No."] = item?.phone || "N/A";
    if (selectedColumns.email) rowData["Email"] = item?.email || "N/A";
    if (selectedColumns.regDateTime) rowData["Registered At"] = item.regDateTime ? formatDateTimeIST(item.regDateTime) : "N/A";
    if (selectedColumns.regCategory) {
      rowData["Stream/Category"] = item?.regCategory?.join(" , ") || "N/A";
    }
    return rowData;
  });
  // console.log(filteredUsers);
  const isUserNotFound = filteredUsers?.length === 0;
  let i = 0;

  return (
    <>
      {loading ? (
        <Stack
          justifyContent="center"
          alignItems="center"
          sx={{ height: "100%" }}
        >
          {" "}
          <SyncLoader color="red" loading={loading} size={20} />
        </Stack>
      ) : (
        <Page title="Students">
          <Container sx={{ position: "absolute", minWidth: "100%" }}>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              mb={3}
            >
              <Typography variant="h3" gutterBottom>
                All User Report
              </Typography>
            </Stack>

            <Card
              sx={{
                width: "100%",
                padding: "16px 24px",
                marginBottom: "20px",
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
                gap: "16px",
                borderRadius: "12px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                border: "1px solid #E2E8F0",
              }}
            >
              <TextField
                name="type"
                label="Type"
                select
                size="small"
                sx={{ flexGrow: 1, minWidth: "120px" }}
                value={type}
                onChange={(e) => setType(e.target.value)}
              >
                <MenuItem value="all">All</MenuItem>
                <MenuItem value="free">Free</MenuItem>
                <MenuItem value="paid">Paid</MenuItem>
              </TextField>
              <TextField
                name="category"
                label="Category"
                select
                size="small"
                sx={{ flexGrow: 2, minWidth: "180px" }}
                value={valueId}
                onChange={(e) => setValueId(e.target.value)}
              >
                <MenuItem value="all">All</MenuItem>
                {streamCategory?.map((item, index) => {
                  return (
                    <MenuItem
                      key={index}
                      value={item?.title}
                    >
                      {item?.title}
                    </MenuItem>
                  );
                })}
              </TextField>
              <TextField
                name="dateRangeOption"
                label="Date Preset"
                select
                size="small"
                value={dateRangeOption}
                onChange={handleDateRangeOptionChange}
                sx={{ flexGrow: 1, minWidth: "120px" }}
              >
                <MenuItem value="today">Today</MenuItem>
                <MenuItem value="1week">1 Week</MenuItem>
                <MenuItem value="1month">1 Month</MenuItem>
                <MenuItem value="custom">Custom</MenuItem>
              </TextField>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Stack
                  direction="row"
                  spacing={2}
                  sx={{ alignItems: "center", flexGrow: 3, minWidth: "360px" }}
                >
                  <DateTimePicker
                    label="From"
                    value={starting}
                    onChange={handleChange}
                    inputFormat="DD/MM/YYYY hh:mm A"
                    renderInput={(params) => (
                      <TextField {...params} size="small" sx={{ flexGrow: 1, width: "100%" }} />
                    )}
                  />
                  <DateTimePicker
                    label="To"
                    value={ending}
                    onChange={handleChangeTwo}
                    inputFormat="DD/MM/YYYY hh:mm A"
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        size="small"
                        sx={{ flexGrow: 1, width: "100%" }}
                      />
                    )}
                  />
                </Stack>
              </LocalizationProvider>

              <Button
                variant="contained"
                onClick={() => handleFilter(type, valueId)}
                sx={{ flexGrow: 0.5, minWidth: "100px", height: "40px" }}
              >
                Search
              </Button>
            </Card>

            <Card>
              <Stack
                pr={3}
                direction="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <UserListToolbar
                  numSelected={selected.length}
                  filterName={filterName}
                  onFilterName={handleFilterByName}
                />

                {/* <ExportCSV csvData={users} fileName='Student Data' /> */}
                <Button
                  variant="outlined"
                  onClick={() => setExportDialogOpen(true)}
                >
                  Export
                </Button>
                <Dialog open={exportDialogOpen} onClose={() => setExportDialogOpen(false)} maxWidth="sm" fullWidth>
                  <DialogTitle sx={{ fontWeight: 'bold', borderBottom: '1px solid #E2E8F0', pb: 2 }}>Export Column Selection</DialogTitle>
                  <DialogContent sx={{ mt: 2 }}>
                    <DialogContentText sx={{ mb: 2, fontWeight: '500', color: 'text.secondary' }}>
                      Select which columns you want to include in your CSV export:
                    </DialogContentText>
                    <FormGroup sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px' }}>
                      <FormControlLabel
                        control={<Checkbox checked={selectedColumns.enrollId} onChange={() => handleColumnToggle('enrollId')} />}
                        label="Enrollment No."
                      />
                      <FormControlLabel
                        control={<Checkbox checked={selectedColumns.name} onChange={() => handleColumnToggle('name')} />}
                        label="Name"
                      />
                      <FormControlLabel
                        control={<Checkbox checked={selectedColumns.phone} onChange={() => handleColumnToggle('phone')} />}
                        label="Phone No."
                      />
                      <FormControlLabel
                        control={<Checkbox checked={selectedColumns.email} onChange={() => handleColumnToggle('email')} />}
                        label="Email"
                      />
                      <FormControlLabel
                        control={<Checkbox checked={selectedColumns.regDateTime} onChange={() => handleColumnToggle('regDateTime')} />}
                        label="Registered At"
                      />
                      <FormControlLabel
                        control={<Checkbox checked={selectedColumns.regCategory} onChange={() => handleColumnToggle('regCategory')} />}
                        label="Stream/Category"
                      />
                    </FormGroup>
                  </DialogContent>
                  <DialogActions sx={{ borderTop: '1px solid #E2E8F0', pt: 2, px: 3, pb: 2 }}>
                    <Button onClick={() => setExportDialogOpen(false)} color="inherit">
                      Cancel
                    </Button>
                    <CSVLink data={csvData} filename="AllUsers.csv" style={{ textDecoration: 'none' }} onClick={() => setExportDialogOpen(false)}>
                      <Button variant="contained" color="primary">
                        Download CSV
                      </Button>
                    </CSVLink>
                  </DialogActions>
                </Dialog>
              
              </Stack>

              <Scrollbar>
                <TableContainer sx={{ minWidth: 800 }}>
                  <Table>
                    <UserListHead
                      order={order}
                      orderBy={orderBy}
                      headLabel={TABLE_HEAD}
                      rowCount={count}
                      numSelected={selected.length}
                      onRequestSort={handleRequestSort}
                      onSelectAllClick={handleSelectAllClick}
                    />
                    <TableBody>
                      {/* {filterSearch?.map((row, index) => { */}

                      {filteredUsers &&
                        filteredUsers
                          // .slice(
                          //   page * rowsPerPage,
                          //   page * rowsPerPage + rowsPerPage
                          // )
                          .map((row, index) => {
                            const { id, purchaseAt, is_paid } = row;

                            const {
                              enrollId,
                              icon,
                              name,
                              phone,
                              email,
                              is_active,
                              regDateTime,
                              regCategory,
                            } = row;
                            // console.log('row',row)
                            const isItemSelected =
                              selected.indexOf(name) !== -1;
                            // row.sno = index + 1 + rowsPerPage * page

                            // console.log(regCategory?.length)
                            return (
                              <TableRow
                                hover
                                key={index}
                                tabIndex={-1}
                                role="checkbox"
                                selected={isItemSelected}
                                aria-checked={isItemSelected}
                              >
                                {/* <TableCell padding="checkbox">
                            <Checkbox checked={isItemSelected} onChange={(event) => handleClick(event, StudentName)} />
                          </TableCell> */}
                                <TableCell>
                                  <Typography variant="subtitle2" noWrap>
                                    {/* {index + 1} */}
                                    {/* {row.sno} */}
                                    {index + 1 + rowsPerPage * page}
                                  </Typography>
                                </TableCell>

                                <TableCell>
                                  <Typography variant="subtitle2" noWrap>
                                    {enrollId}
                                  </Typography>
                                </TableCell>

                                <TableCell component="th" scope="row" pl={2}>
                                  <Stack
                                    direction="row"
                                    alignItems="center"
                                    spacing={2}
                                  >
                                    <Avatar
                                      alt={name}
                                      src={icon}
                                      sx={{ width: 28, height: 28 }}
                                    />
                                    <Typography variant="subtitle2" noWrap>
                                      {name}
                                    </Typography>
                                  </Stack>
                                </TableCell>
                                <TableCell align="left">
                                  {phone ? phone : "NA"}
                                </TableCell>
                                <TableCell align="left">{email}</TableCell>
                                {/* {console.log(regDateTime +"->"+typeof(regDateTime))} */}
                                <TableCell align="left">
                                  {regDateTime ? formatDateTimeIST(regDateTime) : ""}
                                </TableCell>
                                <TableCell align="left">
                                  {regCategory?.map(
                                    (item, index) =>
                                      `${item} ${
                                        index !== regCategory?.length - 1
                                          ? " , "
                                          : ""
                                      }`
                                  )}
                                </TableCell>

                           
                                <TableCell align="left">
                                  <Button
                                    variant="outlined"
                                    size="small"
                                    color="error"
                                    onClick={() =>
                                      navigate(
                                        `/dashboard/students/studentsProfile/${id}`
                                      )
                                    }
                                  >
                                    view
                                  </Button>
                                </TableCell>
                              </TableRow>
                            );
                          })}
                     
                    </TableBody>

                    {isUserNotFound && (
                      <TableBody>
                        <TableRow>
                          <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                            <SearchNotFound searchQuery={filterName} />
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    )}
                  </Table>
                </TableContainer>
              </Scrollbar>

              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={count}
                rowsPerPage={rowsPerPage}
                page={page}
                
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Card>
          </Container>
          <ToastContainer
            position="bottom-center"
            autoClose={1000}
            hideProgressBar
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />
        </Page>
      )}
    </>
  );
}
